// extracted by mini-css-extract-plugin
export default {"reviewsEmptyState":"_112xolq"};